

export enum CourseCatalogProgress {
    SELECT_SESSION_SEMESTER = 0,
    SELECT_SUBJECT = 1,
    SELECT_SECTION = 2,
    CONFIRMATION = 3,
}